import { resolveSticker, Sticker, getSticker } from "../core/stickers";
import { useAppState } from "../hooks/use_app_state";
import "./sticker_menu.css";

interface Props {
  open: boolean;
}

const ALL_STICKERS = Object.values(Sticker).filter(
  (v): v is Sticker => typeof v === "number" && v !== Sticker.UNKNOWN,
);

export function StickerMenu({ open }: Props) {
  const { unlockedStickers, dispatch } = useAppState();

  function onClick(sticker: Sticker) {
    dispatch({
      type: "SEND_MESSAGE",
      payload: {
        sender: "me",
        type: "sticker",
        sticker,
        timestamp: Date.now(),
      },
    });

    const responses = resolveSticker(sticker);
    if (responses.length === 0) return;

    dispatch({ type: "SET_ALI_TYPING", payload: true });

    const delay = 1000 + Math.random() * 2000;
    setTimeout(() => {
      dispatch({ type: "SET_ALI_TYPING", payload: false });
      responses.forEach((s, i) => {
        setTimeout(() => {
          dispatch({
            type: "SEND_MESSAGE",
            payload: {
              sender: "ali",
              type: "sticker",
              sticker: s,
              timestamp: Date.now(),
            },
          });
        }, i * 600);
      });
    }, delay);
  }

  return (
    <div className={`sticker-menu ${open ? "sticker-menu--open" : ""}`}>
      <div className="sticker-menu-grid">
        {ALL_STICKERS.map((sticker) => {
          const unlocked = unlockedStickers.has(sticker);
          const { path } = getSticker(sticker);
          return (
            <button
              key={sticker}
              className={`sticker-menu-item ${unlocked ? "" : "sticker-menu-item--locked"}`}
              disabled={!unlocked}
              onClick={() => onClick(sticker)}
            >
              <img src={path} alt={String(sticker)} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
